import { isSprigInSample, SPRIG_INTEGRATION_NAME } from '@/lib/sprigSampling.js';

export function Segment() {
  const testingStore = useTestingStore();
  const instance = window.analytics || [];
  const isSegmentEnabled = testingStore.hasEnabledFeature('web_segment');
  const { isTrackingAllowed } = checkGdpr();

  const baseIntegrations = {
    'All': false,
    'Actions Google Analytics 4': true,
    'Google Analytics': true,
    'Google Tag Manager': true,
    'Google Analytics 4 Web': true,
    'Facebook Pixel': true,
    'Iterable': true,
    'Iterable (Actions)': true,
    'Talon_One': true,
    'Criteo': true,
    'Button': true,
  };

  const releaseEnv = useRuntimeConfig().public?.RELEASE_ENV;

  const getSegmentIntegration = () => {
    const integrations = { ...baseIntegrations };

    if (isSprigInSample(undefined, undefined, releaseEnv)) {
      integrations[SPRIG_INTEGRATION_NAME] = true;
    }

    return { integrations };
  };

  const checkIfAbleToSendTracking = (values) => {
    if (!isSegmentEnabled) {
      return false;
    }

    if (!isTrackingAllowed) {
      console.log('Tracking not allowed');
      return false;
    }

    if (typeof values !== 'object') {
      console.error('### Segment values are invalid');
      return false;
    }

    if (!instance?.invoked) {
      console.error('### Segment not initialized');
      return false;
    }

    if (!window?.analytics?.track && !window?.analytics?.page) {
      console.error('### Analytics not present on DOM');
      return false;
    }
    return true;
  };

  return {
    onPageView: (values) => {
      if (checkIfAbleToSendTracking(values)) {
        const eventName = values?.event_name;
        delete values?.event_name;

        window?.analytics?.page(eventName, values, getSegmentIntegration());
      }
    },

    onEvent: (values) => {
      if (checkIfAbleToSendTracking(values)) {
        const eventName = values?.event_name;
        delete values?.event_name;

        window?.analytics?.track(eventName, values, getSegmentIntegration());
      }
    },

    onIdentify: (values) => {
      if (checkIfAbleToSendTracking(values)) {
        const {
          email,
          name,
          birthday,
          customerId,
          acceptSocialTerms,
          optOutSocialFeatures,
        } = values;

        if (!window.analytics || !name) {
          return;
        }

        const nameSplit = name?.split(' ');

        window.analytics.identify(
          customerId?.toString(),
          {
            anonymousId: JSON.parse(localStorage.getItem('ajs_anonymous_id')),
            channel: 'browser',
            email,
            birthday,
            social_tcs: acceptSocialTerms.toString(),
            social_features: optOutSocialFeatures.toString(),
            first_name: nameSplit[0],
            last_name: nameSplit.slice(1).join(' '),
          },
          getSegmentIntegration(),
        );
      }
    },

    reset: () => {
      if (!window?.analytics) {
        return;
      }
      window.analytics.reset();
    },
  };
}
